module.exports = __webpack_public_path__ + "static/media/bg-login-signup-blur.4e46b844.png";